import React, {useEffect,useState} from 'react';
import { RadioGroup } from '@headlessui/react'
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
import {Actions as QUIZACTIONS} from '../store/actions/quizActions';
import RegistrationForm from '../components/common/RegistrationForm' 
import { CheckCircleIcon } from '@heroicons/react/20/solid'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function QuizComponent({
  questions,
  saveAnswer,
  nextQuestion,
  restartQuiz,
  questionIndex,
  questionFilter,
  onLastAnswer,
  finishQuizText
}) {

  const [selected, setSelected] = useState(null)

  const questionsToUse = Object.keys(questionFilter).length == 0 ? questions : questions.filter(q => !q.filter || !Object.keys(questionFilter).find((k) => questionFilter[k] != q.filter[k]))


  const question = questionsToUse[questionIndex]
  /*const isMulti = question.type == 'chooseMany'

  const setQuestionAnswer = (value) => {

    console.log('value',value,isMulti,selected)

    if (isMulti){
      let newSelected = []
      if (selected){
        newSelected = selected
      }

      const selectedIndex = newSelected?.findIndex?.(i => i == value)

      if (selectedIndex == -1){
        newSelected.push(value)
      } else {
        console.log('selectedIndex',selectedIndex)
        newSelected.splice(selectedIndex)
      }

      console.log('newSelected',newSelected)

      setSelected(newSelected)
    } else {
      setSelected(value)
    }

  }*/

  if (questionIndex >= questionsToUse.length){
    return (

    <React.Fragment>
      <div className="bg-gray-50 p-10">

        <div className="w-full max-w-xl mx-auto">

          <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10 mb-10">Buddy is a great fit for you</h3>
          <RegistrationForm/>
        </div>

      </div>

    </React.Fragment>
    
  );
  }

  return (

    <React.Fragment>
      <div className="bg-gray-50 p-10">

        <div className="w-full max-w-xl mx-auto">

          <RadioGroup value={selected} onChange={setSelected}>
            <RadioGroup.Label as="h3" className="text-center text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10 mb-10">{question.question}</RadioGroup.Label>
            <div className="space-y-4">
              {question.options.map((option) => {
                const optionValue = (option?.value ?? option)

                return (
                  <RadioGroup.Option
                    key={option?.value ?? option}
                    value={option}
                    className={({ checked, active }) => 
                      classNames(
                        checked ? 'border-transparent' : 'border-gray-300',
                        active ? 'border-orange-500 ring-2 ring-orange-500' : '',
                        'relative block bg-white border rounded-lg shadow-sm px-6 py-4 cursor-pointer sm:flex sm:justify-between focus:outline-none'
                      )
                    }
                  >
                    {({ active, checked }) => (
                      <>
                        <div className="flex items-center">
                          <div className="text-sm">
                            <RadioGroup.Label as="p" className="font-medium text-gray-900">
                              {option?.value ?? option}
                            </RadioGroup.Label>
                            {/*<RadioGroup.Description as="div" className="text-gray-500">
                              <p className="sm:inline">
                                {plan.ram} / {plan.cpus}
                              </p>{' '}
                              <span className="hidden sm:inline sm:mx-1" aria-hidden="true">
                                &middot;
                              </span>{' '}
                              <p className="sm:inline">{plan.disk}</p>
                            </RadioGroup.Description>*/}
                          </div>
                        </div>
                        {/*<RadioGroup.Description as="div" className="mt-2 flex text-sm sm:mt-0 sm:block sm:ml-4 sm:text-right">
                          <div className="font-medium text-gray-900">{plan.price}</div>
                          <div className="ml-1 text-gray-500 sm:ml-0">/mo</div>
                        </RadioGroup.Description>*/}

                        <CheckCircleIcon
                          className={classNames(!checked ? 'invisible' : '', 'h-5 w-5 text-orange-600')}
                          aria-hidden="true"
                        />
                        <div
                          className={classNames(
                            active ? 'border' : 'border-2',
                            checked ? 'border-orange-500' : 'border-transparent',
                            'absolute -inset-px rounded-lg pointer-events-none'
                          )}
                          aria-hidden="true"
                        />
                      </>
                    )}
                  </RadioGroup.Option>
                )}
              )}
            </div>
          </RadioGroup>

          <div className={`${selected ? `cursor-pointer` : `cursor-not-allowed opacity-50`}  bg-orange-600 hover:bg-orange-500 w-full mt-5 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out`}
            onClick={() => {
              if (selected){
                saveAnswer(questionIndex,selected,question.question)
                setSelected(null)
              }
              if(onLastAnswer && questionIndex >=( questionsToUse.length -1)){
                onLastAnswer()
                restartQuiz()
              }
            }}
          >
            { finishQuizText && questionIndex >= ( questionsToUse.length -1) ? finishQuizText : "Next" }
          </div>


          { questionsToUse.length > 1 &&
            <nav className="mt-4 flex items-center justify-center" aria-label="Progress">
              <p className="text-sm font-medium">
                Step {questionIndex + 1} of {questionsToUse.length}
              </p>
              <ol role="list" className="ml-8 flex items-center space-x-5">
                {questionsToUse.map((q,index) => (
                  <li key={index}>
                    {index > questionIndex ? (
                      <span className="block w-2.5 h-2.5 bg-orange-600 rounded-full hover:bg-orange-900">
                        <span className="sr-only">Step {index + 1}</span>
                      </span>
                    ) : index === questionIndex ? (
                      <span className="relative flex items-center justify-center" aria-current="step">
                        <span className="absolute w-5 h-5 p-px flex" aria-hidden="true">
                          <span className="w-full h-full rounded-full bg-orange-200" />
                        </span>
                        <span className="relative block w-2.5 h-2.5 bg-orange-600 rounded-full" aria-hidden="true" />
                        <span className="sr-only">Step {index + 1}</span>
                      </span>
                    ) : (
                      <span className="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                        <span className="sr-only">Step {index + 1}</span>
                      </span>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
          }
        </div>

      </div>

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    questionIndex: state.quiz.index,
    questionFilter: state.quiz.filter,
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  saveAnswer: (questionIndex,answer,question) => dispatch(QUIZACTIONS.saveAnswer(questionIndex,answer,question)),
  nextQuestion: () => dispatch(QUIZACTIONS.nextQuestion()),
  restartQuiz: () => dispatch(QUIZACTIONS.restartQuiz()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuizComponent) 
